export default __webpack_public_path__ + "static/media/search.45ce39ea.svg";